import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {RockBottom} from "../../RockBottom";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../../server/data/RockBottomParsedInitData";
import {ScatterNudgeView} from "../../winpresentation/presentations/ScatterNudgeView";
import {RockBottomSound} from "../../sound/RockBottomSound";
import {RockBottomGameConfig} from "../../RockBottomGameConfig";
import {RockBottomGameMode} from "../../server/RockBottomGameMode";
import {RockBottomSymbolState} from "../../symbol/RockBottomSymbolConfig";
import {RockBottomSymbol} from "../../symbol/RockBottomSymbol";

export class ScatterLandingController extends ReelStopPresentationController {

    protected _scatterCounter: number;
    private readonly _numOfScattersToWin: number = 3;
    private readonly _scattersInReel: boolean[] = [true, true, true, true, true];
    private _animations: TweenLite[] = [];
    private _plusOneSpinView: ScatterNudgeView;
    private _scattersNeededToLevelUp: number = 0;
    private _scatterCollected: number = 0;

    constructor() {
        super("ScatterLandingController");
        this._plusOneSpinView = new ScatterNudgeView();
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        const parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData(),
            scatterPosition = parsedData.scatterPositions![data.reelId],
            nearWinReels: boolean[] = RockBottom.model.parsedGameData.nearWinReels,
            currReel: number = data.reelId,
            nextReel: number = currReel + 1;

        if (nearWinReels.indexOf(true) === nextReel) {
            RockBottom.reelBg.onAnticipation(true);
        }

        if (currReel >= 1 && currReel <= 3 && nearWinReels[nextReel]) {
            RockBottom.anticipationView.toggleScatterAnticipation(nextReel, true);
        }

        if (currReel >= 2 && currReel <= 4 && nearWinReels[currReel]) {
            RockBottom.anticipationView.toggleScatterAnticipation(currReel, false);
        }

        if (currReel === 4) {
            RockBottom.reelBg.onAnticipation(false);
        }

        if (scatterPosition > -1) {
            let symbol: RockBottomSymbol = RockBottom.reels[data.reelId].getSymbol(scatterPosition);
            symbol.getStateAnimation(RockBottomSymbolState.LANDING);
        }

        // When there is not enough reel left to win.
        if (!this.isPossibleToWin(data.reelId)) {
            // also cut off the ongoing animations in previous reels.
            this._animations.forEach(a => a.progress(1));
            return Promise.resolve();
        }
        return super.onReelBounce(data);
    }

    protected onReelStopped(data: IReelStateEventData): Promise<any> {
        //console.log("gaurav - ScatterLandingController", data.reelId);

        const parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData(),
            scatterPosition = parsedData.scatterPositions![data.reelId];

        if (data.reelId === 4) {
            RockBottom.background.stopBoardFlickering();
        }

        if (scatterPosition === -1) {
            return Promise.resolve();
        }

        this._scatterCounter += 1; // To change if more scatter on the one reel.
        if (RockBottom.inBonusGame) {
            RockBottom.freeSpinView.onScatterLanding(this._scatterCounter);
            this.addExtraSpin(data.reelId, scatterPosition);
        }

        //return Promise.resolve(this.playAttentionAnimation(data.reelId, scatterPosition));
        return Promise.resolve();
    }

    protected reset() {
        super.reset();
        this._scatterCounter = 0;
        this._scattersNeededToLevelUp = 0;
        this._scatterCollected = 0;
    }

    protected playScatterSound(NoOfScatters: number): void {
        this._scattersNeededToLevelUp = this._scattersNeededToLevelUp + NoOfScatters;
        if (this._scattersNeededToLevelUp !== 5) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_SOUND_IN_FS});
        } else if (this._scattersNeededToLevelUp === 5) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.BONUS_GAME_FINAL_SCATTER_TO_LEVEL_UP});
        }
    }

    private addExtraSpin(reelId: number, symId: number): void {
        const symbol = RockBottom.reels[reelId].getSymbol(symId);
        if (symbol.symbolName === "S") {
            let positions: PIXI.Point = symbol.getGlobalPosition();
            this._plusOneSpinView.showAddFreespin(positions, 0);
        }
    }

    // override in different scatter winning rules.
    private isPossibleToWin(reelId: number): boolean {
        const data: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData();
        let counter: number = 0;// how many scatters landed
        let reelsLeft: number = 0; // how many possible reels has scatter left
        RockBottom.model.parsedGameData.scatterPositions!.forEach((position, positionId) => {
            if (positionId <= reelId && position > -1) {
                counter++;
            }
            if (positionId > reelId && this._scattersInReel[positionId]) {
                reelsLeft++;
            }
        });
        if (data.mode === RockBottomGameMode.NORMAL) {
            if (counter === 1 && (RockBottom.model.parsedGameData.scatterPositions[reelId] > -1) && !(reelId === 1 && RockBottomGameConfig.IS_BOOSTED_BET)) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_LANDED_1});
            } else if ((counter === 2) && (RockBottom.model.parsedGameData.scatterPositions[reelId] > -1) && !(reelId === 1 && RockBottomGameConfig.IS_BOOSTED_BET)) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_LANDED_2});
            } else if (counter === 3 && (RockBottom.model.parsedGameData.scatterPositions[reelId] > -1)) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_LANDED_3});
                if (data.freespinTriggeredThisSpin) {
                    const fsCount: number = data.freespinsLeft - (data.nudgeSteps.reduce((a, b) => a + b, 0));
                    RockBottom.freeSpinView.updateSpinsCounter(fsCount, false, true);
                }
            } else if (counter === 4 && (RockBottom.model.parsedGameData.scatterPositions[reelId] > -1)) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_LANDED_4});
            } else if (counter === 5 && (RockBottom.model.parsedGameData.scatterPositions[reelId] > -1)) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_LANDED_5});
            }
        }
        if (data.mode === RockBottomGameMode.FREESPIN || data.mode === RockBottomGameMode.SUPER_FREESPIN) {
            if (data.fsLevel === data.fsLevelNextSpin) {
                if ((data.scatterPositions[1] > -1 && reelsLeft === 3) || (data.scatterPositions[2] > -1 && reelsLeft === 2) || (data.scatterPositions[3] > -1 && reelsLeft === 1)) {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SCATTER_SOUND_IN_FS});
                }
            } else if (data.fsLevel !== data.fsLevelNextSpin) {
                if (this._scatterCollected === 0) {
                    this._scatterCollected = data.collectedScatters;
                    for (let reelNo: number = 1; reelNo < 4; reelNo++) {
                        for (let symId: number = 1; symId < data.reels[reelId].length - 1; symId++) {
                            if (data.reels[reelNo][symId] === "S") {
                                this._scatterCollected = this._scatterCollected - 1;
                            }
                        }
                    }
                    this._scattersNeededToLevelUp = (this._scatterCollected % 5);
                }
                if (reelId !== 0 && reelId !== 4) {
                    let bonus_scatter_counter = 0;
                    if (RockBottom.model.parsedGameData.scatterPositions[reelId] > -1) {
                        bonus_scatter_counter++;
                        this.playScatterSound(bonus_scatter_counter);
                    }
                }
            }
        }
        return (counter + reelsLeft) >= this._numOfScattersToWin;
    }

    /*private playAttentionAnimation(reelId: number, symId: number): Promise<any> {
        const symbol = RockBottom.reels[reelId].getSymbol(symId);
        let tween: TweenLite;
        if (this._scatterCounter >= this._numOfScattersToWin) {
            tween = gsap.fromTo(symbol.scale, {x: 1.3, y: 1.3}, {x: 1, y: 1, duration: 1});
        } else {
            tween = gsap.fromTo(symbol.scale, {x: 1.5, y: 1.5}, {x: 1, y: 1, duration: 0.5});
        }
        this._animations.push(tween);
        return Promise.resolve(tween).then(res => {
            ArrayHelper.removeFirstMatchElement(this._animations, tween);
        });
    }*/
}